'use strict';

'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['ircinput'],
    data: function data() {
        return {
            location: _state2.default.setting('imtpLocation'),
            imtpCargando: false,
            imtpError: false
        };
    },
    computed: {
        currentNick: function currentNick() {
            var activeNetwork = _state2.default.getActiveNetwork();
            return activeNetwork ? activeNetwork.nick : '';
        }
    },
    methods: {
        onImtpEnviar: function onImtpEnviar() {
            var _this = this;

            this.imtpCargando = true;
            this.imtpError = false;
            var myFormData = new FormData();
            var imagen = document.getElementById('imtp-imagen').files[0];
            myFormData.append('imagen', imagen);
            myFormData.append('nick', this.currentNick);

            (0, _axios2.default)({
                method: 'post',
                url: 'https://www.imagenes-temporales.com/api/',
                data: myFormData,
                config: {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: 'Client-ID ec08fb234c609fb'
                    }
                }
            }).then(function (response) {
                _this.ircinput.insertText(response.data.data.link);
                _this.$emit('cierraInput');
            }).catch(function (err) {
                _this.imtpError = true;
            }).then(function (response) {
                _this.imtpCargando = false;
            });
        }
    }

};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["inputtools"]) window._kiwi_exports["components"]["inputtools"] = {};
window._kiwi_exports["components"]["inputtools"]["Imtp"]
window._kiwi_exports.components.inputtools.Imtp = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/inputtools/Imtp.vue
// module id = Y7PH
// module chunks = 1